import styled from 'styled-components';

export const ModalContent = styled.div`
  padding: 24px;
`;

export const ModalFooter = styled.div`
  padding: 10px 16px;
  text-align: right;
  border-top: 1px solid #e8e8e8;
  border-radius: 0 0 2px 2px;
`;
